import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Table, Skeleton, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';
import { execFetchFieldSampleVBQL } from '../../models/vbqlResults/vbqlResultsActions';
import Tool from '../../components/Tool';

const InspectorWarning = ({ onBack }) => (
  <Tool
    title="Schema"
    subTitle="Field Inspector"
    onBack={onBack}
  >
    <div style={{ padding: '16px' }}>
      This feature is not supported in the labs environment.
    </div>
  </Tool>
);

export default InspectorWarning;
